import { render, staticRenderFns } from "./AcademicDataEditHistory.vue?vue&type=template&id=519d8c8e&scoped=true"
import script from "./AcademicDataEditHistory.vue?vue&type=script&lang=js"
export * from "./AcademicDataEditHistory.vue?vue&type=script&lang=js"
import style0 from "./AcademicDataEditHistory.vue?vue&type=style&index=0&id=519d8c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d8c8e",
  null
  
)

export default component.exports